var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDamageMissingTrims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.752 192h-64v128h64v-128zM555.264 213.248c76.544 0 153.088 6.144 229.376 18.432l20.736 3.584 19.712 3.328 46.080 156.16 52.48-27.392 29.952 56.832-54.272 28.672 17.92 35.84v314.88h-64v-299.52l-24.576-49.664c-81.749 18.182-176.131 29.299-272.863 30.708l-1.057 0.012c-87.040 0.512-179.2-8.192-276.48-25.856l-22.272 44.8v299.52h-64v-314.88l44.8-89.856 47.616-160.256 19.456-3.328c84.48-14.592 168.192-22.016 251.392-22.016zM303.616 398.336c88.576 15.36 172.032 23.040 250.88 22.272 89.068-1.245 175.117-10.972 258.329-28.411l-8.729 1.531-29.184-98.304h-0.256c-66.56-10.752-133.12-16.64-199.424-17.664h-19.968c-66.304 0-133.12 4.864-200.192 14.592l-20.736 3.072-30.72 102.912zM405.248 567.296h-85.248v64.512h85.248v-64.512zM789.248 567.296h-85.248v64.512h85.248v-64.512zM640 567.296h-170.752v64.512h170.752v-64.512zM363.52 728.576h382.208l25.6 54.528-57.856 27.648-8.448-17.92h-300.8l-8.448 17.92-57.856-27.648 25.6-54.784zM21.504 379.904l22.016-60.16 120.32 43.776-22.016 60.16-120.32-43.776zM160.768 496.896l-40.96-49.152-98.304 82.176 41.216 49.152 98.048-82.176z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageMissingTrims);
export default __webpack_public_path__ + "static/media/damage_missing_trims.773ef2e44c5d1c47d0b89946e89aaa9d.svg";
export { ForwardRef as ReactComponent };